<script setup>
import axios from "@/plugins/axios";
import {ref, defineEmits} from "vue";
import toast from "@/plugins/bulmatoast";


let emits = defineEmits(["cancel"])


const registrationForm = ref(
    {
      email: null,
      password: null,
    }
)


const fetchRegistration = () => {
  axios.post("/customer/cabinet/register/", registrationForm.value).then(() => {
    toast({
      message: "Письмо подтверждения выслано на указанный email",
      type: "is-success",
    });
    emits("cancel");
  }).catch(error => {
    toast({
      message: error.response.data.detail,
      type: "is-danger",
    });
  })
}
</script>

<template>
  <v-dialog>
    <v-form>
      <v-text-field
          v-model="registrationForm.email"
          label="email"
          type="email"
      ></v-text-field>
      <v-text-field
          v-model="registrationForm.password"
          label="Пароль"
          type="password"
      ></v-text-field>
      <div style="display: flex">
        <v-btn class="mr-5" @click="emits('cancel')">
          Отменить
        </v-btn>
        <v-btn color="primary" @click="fetchRegistration()">
          Отправить
        </v-btn>
      </div>
    </v-form>
  </v-dialog>
</template>

<style scoped>

</style>